// @flow
import React, {PureComponent} from 'react';
import type {Subscription} from 'digicel-kaizen-library';
import {StyleSheet, TouchableOpacity, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import I18n from '../../../../../lib/i18n';
import theme from '../../../../../theme-config';

export default class NewPlanWithNewNumber extends PureComponent<Props> {
  render() {
    if (this.props.hasSubscriptionsWithNoOptions) return null;
    return (
      <View
        style={[
          styles.pageContainer,
          this.props.isHighlighted && styles.isHighlighted,
        ]}>
        <TouchableOpacity style={styles.container} onPress={this.props.onPress}>
          <View style={styles.line}>
            <Text style={styles.text}>
              {I18n.t('SignUp.SelectSubscriptionToActivatePage.createLine')}
            </Text>
          </View>
        </TouchableOpacity>
        <View style={styles.separator} />
      </View>
    );
  }
}

export type StateProps = {
  hasSubscriptionsWithNoOptions: boolean,
  isCurrentSubscription: (?Subscription) => boolean,
  onPress?: Function,
  style?: any,
  isHighlighted?: boolean,
};

type Props = StateProps;

const styles = StyleSheet.create({
  pageContainer: {
    flex: 1,
    backgroundColor: theme.overPrimaryColor,
  },
  container: {
    paddingVertical: 10,
    paddingHorizontal: 16,
  },
  line: {
    marginVertical: 4,
    marginLeft: 25,
  },
  text: {
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
  },
  separator: {
    width: '100%',
    height: 1,
    backgroundColor: theme.separatorColor,
  },
  isHighlighted: {
    backgroundColor: theme.selectedBackground,
  },
});
